import EventEmitter from 'eventemitter3'
import router from '../router'
import { store } from '../store/store'

class AuthService {
  constructor() {
    this.login = this.login.bind(this)
    this.logout = this.logout.bind(this)
    this.isAuthenticated = this.isAuthenticated.bind(this)
    this.authenticated = this.isAuthenticated()
    this.authNotifier = new EventEmitter()
  }

  login() {
    router.push('/session/login')
  }

  logout() {
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    this.authNotifier.emit('authChange', { authenticated: false })
    router.push('/session/login')
  }

  isAuthenticated() {
    return !!store.getters.getAccessToken
  }
}

export default AuthService
